import React, { useState } from "react";
import { getAccessToken } from "../helpers/api/getAccessTokenSilently";

const FileUploadComponent = () => {
  const [uploadType, setUploadType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setMessage(null);
  };

  const handleUpload = async () => {
    if (!uploadType) {
      setMessage("Please select upload type.");
      return;
    }
    if (!selectedFile) {
      setMessage("Please select a file to upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      setLoading(true);
      setMessage(null);
      const token = await getAccessToken();
      const response = await fetch(
        uploadType === "category" ? "https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/WWF-V2/upload-project-category-excel" : 
        "https://q54lderfwbhrpereajs6fvethu0ebrsk.lambda-url.ap-south-1.on.aws/WWF-V2/upload-user-data-excel",
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: formData,
        }
      );

      if (response.ok) {
        setMessage("File uploaded successfully!");
        setSelectedFile(null);
        setUploadType("");
      } else {
        const errorText = await response.text(); // 🔹 Capture API error response
        setMessage(`File upload failed: ${errorText}`);
      }
    } catch (error) {
      console.error("Upload error:", error);
      setMessage("An error occurred during upload.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Upload type selection */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Select Type
        </label>
        <select
          value={uploadType}
          onChange={(e) => {
            setUploadType(e.target.value);
            setSelectedFile(null);
            setMessage(null);
          }}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Choose Upload Type</option>
          <option value="category">Project Category</option>
          <option value="users">User Mapping</option>
        </select>
      </div>

      {/* Render file upload only if type selected */}
      {uploadType && (
        <>
          {/* File input */}
          <div className="mb-3">
            <input
              type="file"
              onChange={handleFileChange}
              className="block w-full text-sm text-gray-700 border border-gray-300 rounded-md px-3 py-2 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Upload button (center aligned) */}
          <div className="flex justify-center">
            <button
              onClick={handleUpload}
              disabled={loading}
              className={`${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              } text-white px-5 py-2 rounded-md shadow-sm`}
            >
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </>
      )}

      {/* Message */}
      {message && (
        <p
          className={`mt-3 text-sm ${
            message.includes("successfully")
              ? "text-green-600"
              : "text-red-600"
          } text-center`}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default FileUploadComponent;
